import React from "react";
import "./Invoice.css";
import logo from "../../assets/images/logo.png"; // ✅ Recommended ES import

// Import shared layout components
import MainNavbar from "../../pages/MainNavbar";
import Breadcrumbs from "../Breadcrumbs";
import Footer from "../footers";

// Mock Auth Context (optional, if used for MainNavbar)
import { useAuth } from "../../context/AuthContext";

interface InvoiceItem {
  description: string;
  unitPrice: number;
  discount: number;
  reward: number;
  qty: number;
  netAmount: number;
  taxRate: number;
  taxType: string[];
  taxAmount: number[];
  totalAmount: number;
}

const Invoice: React.FC = () => {
  const { currentUser } = useAuth();
  const userId = currentUser?.id || "";
  const isLoggedIn = !!currentUser;

  const items: InvoiceItem[] = [
    {
      description: "XYZ",
      unitPrice: 3250,
      discount: 0,
      reward: 300,
      qty: 2,
      netAmount: 6200,
      taxRate: 9,
      taxType: ["CGST", "SGST"],
      taxAmount: [558, 558],
      totalAmount: 7316,
    },
    {
      description: "Shipping Charges",
      unitPrice: 0,
      discount: 0,
      reward: 0,
      qty: 0,
      netAmount: 0,
      taxRate: 5,
      taxType: ["CGST", "SGST"],
      taxAmount: [0, 0],
      totalAmount: 0,
    },
  ];

  const totalTax = items.reduce(
    (acc, item) => acc + item.taxAmount.reduce((a, b) => a + b, 0),
    0
  );
  const totalAmount = items.reduce((acc, item) => acc + item.totalAmount, 0);

  return (
    <>
      {/* ✅ Shared Navbar */}
      <MainNavbar
        searchQuery=""
        setSearchQuery={() => {}}
        isLoggedIn={isLoggedIn}
        showSubnav={false}
        setShowSubnav={() => {}}
        userId={userId}
        disableSearch={true}
      />

      {/* ✅ Breadcrumbs */}
      <Breadcrumbs />

      {/* ✅ Invoice Container */}
      <div className="invoice-page">
        <div className="invoice-container">
          {/* Header */}
          <div className="invoice-header">
            <div className="logo_invoice">
              <img
                src={logo}
                alt="LNG Mart Logo"
                className="logo-img"
              />
            </div>

            <div className="invoice-title">
              <strong>Tax Invoice / Bill of Supply</strong>
              <div>(Original for Recipient)</div>
            </div>
          </div>

          {/* Seller & Address Info */}
          <div className="invoice-section">
            <div>
              <strong>SOLD BY :</strong>
              <div>RK Worldcom Pvt Ltd</div>
              <div>Seller Address</div>
              <br />
              <div>PAN NO:</div>
              <div>GST Registration No:</div>
              <div>FSSAI License No:</div>
              <br />
              <div>Order Number:</div>
              <div>Order Date:</div>
            </div>

            <div className="invoice-address">
              <div>
                <strong>Billing Address</strong>
                <div>Ganesh Achari</div>
                <div>Ghandinagar Sirsi Uttara Kannada</div>
                <div>Pin code 581401, IN</div>
                <br />
                <div>Invoice Number:</div>
                <div>Invoice Date:</div>
              </div>

              <div>
                <strong>Shipping Address</strong>
                <div>Ganesh Achari</div>
                <div>Ghandinagar Sirsi Uttara Kannada</div>
                <div>Pin code 581401</div>
              </div>
            </div>
          </div>

          {/* Invoice Table */}
          <table className="invoice-table">
            <thead>
              <tr>
                <th>SL No</th>
                <th>Description</th>
                <th>Unit Price</th>
                <th>Discount</th>
                <th>Reward</th>
                <th>Qty</th>
                <th>Net Amount</th>
                <th>Tax Rate</th>
                <th>Tax Type</th>
                <th>Tax Amount</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.description}</td>
                  <td>{item.unitPrice}</td>
                  <td>{item.discount}</td>
                  <td>{item.reward}</td>
                  <td>{item.qty}</td>
                  <td>{item.netAmount}</td>
                  <td>{item.taxRate}%</td>
                  <td>
                    {item.taxType.map((t, i) => (
                      <div key={i}>{t}</div>
                    ))}
                  </td>
                  <td>
                    {item.taxAmount.map((a, i) => (
                      <div key={i}>{a}</div>
                    ))}
                  </td>
                  <td>{item.totalAmount}</td>
                </tr>
              ))}
              <tr className="total-row">
                <td colSpan={9} style={{ textAlign: "right" }}>
                  TOTAL:
                </td>
                <td>{totalTax}</td>
                <td>{totalAmount}</td>
              </tr>
            </tbody>
          </table>

          {/* Amount in Words */}
          <div className="amount-in-words">
            <strong>Amount in words:</strong> Seven Thousand Three Hundred
            Sixteen Only.
          </div>

          {/* Footer Signature */}
          <div className="invoice-signature">
            <div>
              <strong>For R K Worldcom Pvt Ltd</strong>
            </div>
            <div className="signatory">Authorized Signatory</div>
          </div>
        </div>
      </div>

      {/* ✅ Shared Footer */}
      <Footer />
    </>
  );
};

export default Invoice;
